<template>
    <div  class="ballot" v-if="vodeOption">
        <div class="ballot-title">
            <!-- <img :src="titleIcon" /> -->
            <p>{{vodeOption.title}}</p>
             <!-- <span>{{vodeOption.type=='radio'?'（单选）':mutiTitle}}</span> -->
        </div>
        <!-- 投票结果-->
        <div class="ballot-result" v-if="isResult">
            <i v-if="vodeOption.options.length>0"></i>
            <div :class="voteSelectedList.indexOf(item.id+'')>=0 ?
                 (item.imageUrl? 'item item-checked imageUrl':isSharePage ? 'item noimageUrl':'item item-checked noimageUrl')
                :(item.imageUrl? 'item  imageUrl':isSharePage ? 'item  noimageUrl':'item  noimageUrl')" 
            v-for="item in vodeOption.options" :key="item.id"  
            :style="voteSelectedList.indexOf(item.id+'')>=0?
            'background:linear-gradient(to right, rgba(237,244,254,1)' +item.percentage+'%, rgba(255,255,255,1)' + item.percentage + '%'
            :'background:linear-gradient(to right, rgba(249,249,249,1)' +item.percentage+'%, rgba(255,255,255,1)' + item.percentage + '%'" 
            >
                <div  class="itemImg" v-if="item.imageUrl">
                    <img :src="item.imageUrl"/>
                </div>
                <div class="item-title">
                    <span style="-webkit-box-orient: vertical; text-align: left" >{{item.title}}</span>
                    <img class="votechecked-img" v-if="voteSelectedList.indexOf(item.id+'')>=0" :src="voteChecked" />
                </div>   
                <div class="item-percentage" >{{item.percentage||'0.0'}}%</div>
            </div>
        </div>
        <div v-else class="ballot-list" style='position: relative'>
            
             <!-- 单选-->
            <div v-if="vodeOption.type=='radio'">
                <i v-if="vodeOption.options.length>0"></i>
                <div :class="item.imageUrl ?'item imageUrl':'item noimageUrl'"  
                 v-for="item in vodeOption.options" :key="item.id" @click="addVote(item,'radio')">
                    <div  class="itemImg" v-if="item.imageUrl">
                        <img :src="item.imageUrl"/>
                    </div>
                    <div class="item-title">
                        <span style="-webkit-box-orient: vertical;">{{item.title}}</span></div>   
                <!-- <div class="item-percentage" v-if="item.percentage">{{item.percentage}}%</div> -->
                </div>
            </div>
             <!-- 多选-->
            <div v-else-if="vodeOption.type=='checkbox'" >
                <i v-if="vodeOption.options.length>0" style='padding:0 4px; left: -6px;'></i>
                <div class="checkbox-box"  v-for="item in vodeOption.options" :key="item.id"  @click="handleItemClick(item.id)" >
                    <!-- <div class="checkbox">
                        <span :class="voteSelectedList.indexOf(item.id+'')>=0?'checked':''">0</span>
                    </div> -->
                    <div :class="item.imageUrl ?'checkbox-item item imageUrl':'checkbox-item item noimageUrl'" style='padding: 0.333333rem 0;'>
                        <div class="checkbox">
                            <span :class="voteSelectedList.indexOf(item.id+'')>=0?'checked':''"></span>
                        </div>
                        <div  class="itemImg" v-if="item.imageUrl">
                            <img :src="item.imageUrl"/>
                        </div>
                        
                        <div class="item-title">
                            <span style="-webkit-box-orient: vertical;">{{item.title}}</span>
                        </div>   
                    </div>
                </div>
                <div class="btn-ok" @click="addVote([],'checkbox')" v-if="!isSharePage">投票</div>
            </div>
            
        </div>
        <!-- <div class="btn-ok"  @click="openDialog" v-if="isSharePage">投票</div> -->
        <!-- 弹窗 -->
        <dialogComponent 
			:params="dialogParams"
			:is-show="isShowDialog" 
			@on-close="closeDialog" 
			@on-ok="okDialog"
		>
			<div class="dialog_publish_main" slot="main">
				即将离开当前页面<br>打开“成都日报锦观”客户端
			</div>
		</dialogComponent>
    </div>
</template>
<script>
import Vue from 'vue'
import { Checklist,Toast } from 'mint-ui';
import api from 'src/constants/appapi'
import titleIcon from 'src/images/vote_icon.png'
// import voteChecked from 'src/images/vote_checked.png'
import voteChecked from 'src/images/icon_Select@2x.png'
import { intfc_prefix_common} from 'constants/project'
import dialogComponent from './dialog';
Vue.use(Checklist)
export default {
    components:{
        dialogComponent
    },
    data(){
        return {
            voteChecked,
            titleIcon,
            isLogin:0,//未登录
            vodeOption:null,
            voteSelectedList:[],
            isResult:false, //未投票
            voteType:'radio',
            radioItem:'',
            isVoteResult:[],
            isShowDialog: false,
            dialogParams:{}
        }
    },
    props:{
        voteObj:{
           type: Object,
			default() {
				return {};
			}
        }
    },
    
    watch:{
        isLogin:function(newval,oldval){
            if(newval == 1){
                this.addVote(this.radioItem,this.voteType)
            }
            console.log(newval,oldval,'watchisLogin')
        },
        isVoteResult:function(newval,oldval){
            console.log(newval,oldval,'watchisVoteResult')
            this.voteSelectedList = newval || oldval
            if(this.voteSelectedList.length>0) this.isResult = true
        },
        voteObj(newval,oldval){
            console.log(newval,oldval,'newval')
            if(newval){
                this.getVote(this.newval.voteId)
            }
        }
    },
    computed:{
        mutiTitle: function () {
            let t = '（多选，'
            if(this.vodeOption.isFix) {
                t += '每人固定'+this.vodeOption.fixedNum
            } else {
                t += '每人至少选'+this.vodeOption.minNum
            }
            return t+'项）'
        }
    },
  
    methods:{
        
        handleItemClick(itemId){
            /**isFix true固定 false至少
                fixedNum:对应固定几个选项
                minNum:对应至少几个选项
            **/
            const idx = this.voteSelectedList.indexOf(itemId+'')
            //debugger;
            if (idx >= 0){
                this.voteSelectedList.splice(idx, 1)
            }
            else {
                this.voteSelectedList.push(itemId+'')
                if(this.vodeOption.isFix){
                    if(this.voteSelectedList.length>this.vodeOption.fixedNum){
                        this.voteSelectedList.splice(idx, 1)
                    }
                }
                
            }
        },
        	// 打开弹窗
		openDialog(options){
            console.log("rerere")
			// this.isShowDialog = true;
			// this.dialogParams = {
			// 	articleId:this.vodeOption.id,
			// 	categoryId:this.vodeOption.categoryId,
			// 	sysCode:this.vodeOption.sysCode||"",
			// 	type:this.vodeOption.type || this.vodeOption.sysCode || "",
			// 	link:this.vodeOption.link|| ""
        	// }
		},
		// 关闭弹窗
        closeDialog(){
			this.isShowDialog = false
		},
		// 确定
		okDialog(){
			this.isShowDialog = false;
		},
        addVote(item,type){
            let _this=this
            _this.radioItem = item
            _this.voteType = type
            if(!_this.isSharePage){
                if(!_this.isLogin){
                    _this.appPostMessage('userLogin','')
                }
                console.log(_this.isLogin,'this.isLogin')
                if(_this.isLogin){
                    if(type=='checkbox'){
                        /**isFix true固定 false至少
                            fixedNum:对应固定几个选项
                            minNum:对应至少几个选项
                        **/
                        if(this.vodeOption.isFix){
                            if(this.voteSelectedList.length != this.vodeOption.fixedNum){
                                Toast(`还需选择${this.vodeOption.fixedNum-this.voteSelectedList.length}项`);
                                return;
                            } 
                        }else {
                            if(this.voteSelectedList.length<this.vodeOption.minNum){
                                Toast(`还需选择${this.vodeOption.minNum - this.voteSelectedList.length}项`);
                                return;
                            }
                        }
                        _this.$axios.post(`${intfc_prefix_common}/api/v2/vote/clientVote/${this.voteObj.voteId}/voteOptionIds?voteOptionIds=${this.voteSelectedList.join()}`)
                        .then(res=>{
                            if(res.code ==0){
                                this.isResult = true
                                let obj=_this.voteObj.voteId+"|"+ this.voteSelectedList.join()
                                console.log(obj,JSON.stringify(obj),'test')
                                _this.appPostMessage('toVoteParams',obj)
                                _this.getVote(_this.voteObj.voteId)
                            }
                        })
                    }else{
                        this.voteSelectedList.push(item.id+'')
                        _this.$axios.post(`${intfc_prefix_common}/api/v2/vote/clientVote/${this.voteObj.voteId}/voteOptionIds?voteOptionIds=${item.id}`)
                        .then(res=>{
                            if(res.code ==0){
                                this.isResult = true
                                let obj=_this.voteObj.voteId+"|"+item.id
                                _this.appPostMessage('toVoteParams',obj)
                                _this.getVote(_this.voteObj.voteId)
                            }
                        })
                    }
                }
            }
        },
        appPostMessage (name, value='') {
            // 调用app原生方法
            if (name) window.appapi.appPostMessage(name, value)
        },
        getVote(voteId){
            this.$axios.get(`${intfc_prefix_common}/api/v2/vote/getVoteInfo/${voteId}`)
                .then(res=>{
                    if(res.code ==0){
                        this.appPostMessage('getVoteFinish')
                        this.vodeOption = res.item
                        let n = 0
                        this.vodeOption.options.map((item)=>{
                            if(item.imageUrl) n++
                        })
                        if(n!=0){
                            this.vodeOption.options.map((item)=>{
                              if(!item.imageUrl){
                                    this.$nextTick(function() {
                                        // 计算内容高度
                                        const item = this.$el.querySelectorAll('.ballot-result .noimageUrl');
                                        console.log(item,'item')
                                        for(let i=0;i<item.length;i++){
                                          item[i].style.height="1rem";
                                        }
                                    });
                              }  
                            })
                        }
                        if(n==0){
                            this.vodeOption.options.map((item)=>{
                                if(item.title.length>16){
                                    this.$nextTick(function() {
                                        // 计算内容高度
                                        const item = this.$el.querySelectorAll('.ballot-result .item');
                                        for(let i=0;i<item.length;i++){
                                            item[i].style.height="1rem";
                                        }
                                    });
                                }
                            })
                        }
                        if (this.isSharePage) this.isResult = true
                    }
                })
        }
    },
    mounted(){
        if(this.voteObj){
            this.getVote(this.voteObj.voteId)
        }
         console.log(this.$refs['hello']);
    },
    created(){
        // 暴露方法给webview
        window.appapi = api
        window.$vm = this
        this.isSharePage=appapi.isSharePage()
        console.log(this.isSharePage )
         
   }
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
    @import "~src/stylus/mixin";
    .ballot
        // margin: 50px 30px;
        width: 100%;
        background:url('~images/bg_vote@2x.png') no-repeat top/100%;
        overflow: hidden;
        .ballot-title
            width: 750px;
            // height: 212px;
            text-align: center;
            // background:url('~images/bg_vote@2x.png') no-repeat 100%/100%;
            overflow:hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top:80px;
            p
                font-size: 32px;
                line-height: 50px;
                // font-weight: bold;
                color: #222;
                // position: relative;
                margin:10px 145px;
                font-family: FZZYSJW--GB1-0;
            img 
                width: 56px;
                height: 32px;
                margin-right 20px
                margin-top 15px
                position: relative;
                top: 5px;
        .ballot-result 
            margin: 0 60px 50px;
            position: relative;
            i
                display:block;
                position:absolute;
                top:0;
                left:-.5%;
                width:101%;
                height:8px;
                background:#6787B2;
                border-radius:10px;
            .item 
                margin-top: 18px;
                padding: 25px 20px;
                border: 2px solid #E2E4EA;
                box-shadow: 0 4px 8px 6px rgba(174,202,239,0.11);
                border-radius: 6px;
                text-align: center;
                font-size: 28px;
                color: #888;
                line-height 38px;
                display: flex;
                .item-bg 
                    background #edf4fe;
                .item-title
                    // justify-content: center;
                    align-items: center;
                    display: flex;
                    width 80%;
                .itemImg
                    width 224px;
                    height 140px;
                    margin-right 20px;
                    border-radius: 8px;
                    img 
                        width 100%;
                        height 100%;
                .item-percentage
                    width 20%
                    display: flex;
                    justify-content: center;
                    align-items: center;
                span 
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                .votechecked-img
                    width 22px;
                    height 14px;
                    margin-left: 10px;
            .item-checked
                border 2px solid #415D89 !important;
                color #415D89
        .ballot-list
            margin: 0px 60px 0;      
        .ballot-list i
            display:block;
            position:absolute;
            top:3px;
            left:-.5%;
            width:101%;
            height:8px;
            background:#6787B2;
            border-radius:10px;
        .ballot-list .item
            padding: 25px 10px;
            // border: 2px solid #e1e4ea;
            border-radius: 6px;
            text-align: center;
            font-size: 32px;
            color: #415d89;
            line-height 38px;
            // height 112px;
            display: flex;
            // border: 2px solid #E2E4EA;
            box-shadow: 0 4px 8px 6px rgba(174,202,239,0.11);
            margin-bottom: 18px;
            .itemImg
                width 256px;
                height 120px;
                margin-right 20px;
                img 
                    width 100%;
                    height 100%;
            .item-bg 
                background #edf4fe;
            .item-title
                justify-content: center;
                align-items: center;
                display: flex;
                width 100%;
            .item-percentage
                width 20%
                display: flex;
                justify-content: center;
                align-items: center;
            span 
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
    .checkbox-box
        // display: flex;
        // justify-content: center;
        // align-items: center;
        padding-top: 20px;
        background:#fff;
        .item
            margin-top:0 !important;
            display: flex;
            justify-content: center;
            align-items: center;
        .checkbox
            padding 0 20px 
            span 
                display inline-block
                width 24px
                height 24px
                background url("~images/choice_nor@2x.png") center/cover no-repeat
                &.checked
                    background-image url("~images/choice_sele@2x.png")
        .checkbox-item
            width 100%
    .btn-ok
        // background: #d2494a;
        border: 2px solid #D4282B;
        border-radius: 35px;
        color:#D4282B;
        font-size: 32px;
        width: 384px;
        height: 70px;
        text-align center
        line-height 70px
        margin-top: 40px
        letter-spacing: 2px;
        justify-content: center;
        margin: 0.533rem auto 0 auto;
.dialog_publish_main
    font-family: PingFangSC-Medium;
    font-size: 36px;
    color: #222222;
    letter-spacing: 0;
    text-align: center;
</style>


// WEBPACK FOOTER //
// page-vote.vue?36d5937d